import { useState, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import FormInput from '../../../Utilities/FormInput/FormInput';
import PrimaryButton from '../../../Utilities/PrimaryButton/PrimaryButton';

import './VerifyEmailForm.scss';

import authAPI from '../../../../Data/Auth';
import CustomToast from '../../../Utilities/Toast/Toast';
import SecondaryButton from '../../../Utilities/SecondaryButton/SecondaryButton';
import LoadingPage from '../../../Utilities/LoadingPage/LoadingPage';

function VerifyEmailForm(props) {
    const [ isVerifying, setIsVerifying ] = useState(false);
    const [ disabledButton, setDisabledButton ] = useState(true);

    const verifyEmailFormData = {
        email: {
            label: "",
            ref: useRef(''),
            value: '',
            width: 8, // x < 12
            type: "text",
            required: true,
            // numeric: true,
            placeholder: 'Masukkan email yang sudah terdaftar...'
        },
    }

    const [formData, setFormData] = useState(verifyEmailFormData);
    // const navigation = useContext(NavigationContext);
    
    const [toastContent, setToastContent] = useState({
        title: '',
        content: '',
        status: null,
        show: false
    });

    const closeToast = () => {
        setToastContent({
            ...toastContent,
            show: false
        });
    }

    const openToast = (isSuccess, message) => {
        const content = toastContent;

        content.title = isSuccess ? 'Success' : 'Failed';
        content.content = message;
        content.status = isSuccess;
        content.show = true;

        setToastContent({
            ...content
        });
    }

    const verifyEmail = () => {
        if( disabledButton ) return ;

        setIsVerifying(true);

        const email = formData.email.ref.current.value;

        (
            async() => {
                const response = await authAPI.verifyEmail(email);

                if(response.hasOwnProperty('errorCode') && response.errorCode === 0) {
                    // Redirect to email sent notification!
                    setDisabledButton(true);
                    setTimeout(() => {
                        props.onBack();
                    }, 5000);
                } else {
                    for(let index in response.data) {
                        let item = response.data[index];
                        let field = item.hasOwnProperty('field') ? item.field : '';
                        let message = item.hasOwnProperty('message') ? item.message : '';

                        if(field !== '' && formData.hasOwnProperty(field)) {
                            formData[field].hasError = true;
                            formData[field].errorMessage = message;
                        }
                    }

                    setFormData({
                        ...formData
                    });
                }
                
                setIsVerifying(false);
                openToast(
                    response.hasOwnProperty('errorCode') && response.errorCode === 0 ? 1 : 0,
                    response.message
                );
            }
        )();
    };

    return (
        <>
            <CustomToast show={toastContent.show} 
                onClose={closeToast} 
                title={toastContent.title} 
                status={toastContent.status}
                customClass="account-modify-toast"
            >
                <div className="content">
                    { toastContent.content }
                </div>
            </CustomToast>
            <div className='verify-email-form-container'>
                <Row className="verify-email-form-title">
                    <Col sm={12}>
                        <h2> Verifikasi Email </h2>
                        <p> Masukkan email yang terdaftar untuk verifikasi. </p>
                    </Col>
                </Row>
                <Row className={`verify-email-form`}>
                    {
                        Object.keys(formData).map( (key, index) => {
                            let item = formData[key];

                            return <FormInput 
                                        key={index} 
                                        attribute={item}
                                        options={item.hasOwnProperty('options') ? item.options : []}
                                        name={key} 
                                        onChange={ (name, value) => {
                                            console.log(value);
                                            if( value && disabledButton ) {
                                                setDisabledButton(false);
                                            } else if( value === "" && !disabledButton ) {
                                                console.log("Disabled!");
                                                setDisabledButton(true);
                                            }
                                        } } 
                                    />
                        } )
                    }
                </Row>
                <Row>
                    <Col sm={4}>
                        {
                            isVerifying ? (
                                <LoadingPage />
                            ) : (
                                <PrimaryButton disabled={disabledButton} size="sm" customClass="btn-verify-email-form" onClick={() => verifyEmail()}>
                                    Verify
                                </PrimaryButton>
                            )
                        }
                    </Col>
                    <Col sm={4}>
                        <SecondaryButton size="sm" customClass="btn-back" onClick={() => { props.onBack() }}>
                            Back
                        </SecondaryButton>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default VerifyEmailForm;